import { VideoStartEvent, VideoStateChangeEvent } from '../../types'
import { BaseVideoPlayer } from './BaseVideoPlayer'
import { isErtDebugModeEnabled, getVideoIdentifier } from '../../rrwebUtils'
import { createRef, RefObject } from 'react'
import { flushSync } from 'react-dom'
import ReactDOM from 'react-dom/client'

export class VanillaPlayer extends BaseVideoPlayer {
  constructor(
    initialParent: HTMLElement,
    videoStartEvent: VideoStartEvent,
    videoStateChangeEvents: VideoStateChangeEvent[],
    options?: { mockVideoElement?: HTMLVideoElement }
  ) {
    const videoShellRef = createRef<HTMLDivElement>()
    const videoElementRef = createRef<HTMLVideoElement>()
    renderVideo(initialParent, videoShellRef, videoElementRef, videoStartEvent)

    // this allows us to instantiate this player in tests
    videoElementRef.current = options?.mockVideoElement ?? videoElementRef.current

    if (!videoShellRef.current || !videoElementRef.current) {
      throw new Error('Video shell or element not properly initialized')
    }

    super(initialParent, videoShellRef.current, videoElementRef.current, videoStartEvent, videoStateChangeEvents)
  }
}

function renderVideo(
  appendTo: HTMLElement,
  videoShellRef: RefObject<HTMLDivElement | null>,
  videoElementRef: RefObject<HTMLVideoElement | null>,
  videoStartEvent: VideoStartEvent
) {
  flushSync(() => {
    ReactDOM.createRoot(appendTo).render(
      <div ref={videoShellRef} title={isErtDebugModeEnabled() ? getVideoIdentifier(videoStartEvent) : undefined}>
        <video
          ref={videoElementRef}
          src={videoStartEvent.streamingSessionURL}
          preload="auto"
          controls={isErtDebugModeEnabled()}
          style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center' }}
        />
      </div>
    )
  })
}
